export default {"src":"/_next/static/media/icon_withdrawal_option_instant_bank.8c3e1e6c.svg","height":36,"width":42,"blurWidth":0,"blurHeight":0};